import { render, staticRenderFns } from "./MenuItemSkeleton.vue?vue&type=template&id=890590ec&"
import script from "./MenuItemSkeleton.vue?vue&type=script&lang=js&"
export * from "./MenuItemSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports